import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import HeaderNav from "../headerNav";

import Footer from "../footer";
import datePlans from "./datePlans";

import "./index.scss";

const Plans = () => {
  const [selectedPlan, setSelectedPlan] = useState(null);

  const navigate = useNavigate();

  const handleSelectPlan = (plan) => {
    setSelectedPlan(plan);
    Swal.fire({
      text: "Continue na pagina de Inscrição...",
      icon: "success",
      timer: 3000,
      showConfirmButton: false,
      willClose: () => {
        navigate("/register");
      },
    });
  };

  const plans = datePlans.map((plan) => (
    <li key={plan.id} className="list-iten">
      <img
        className="plans-img"
        src={plan.img}
        alt="imagens descrições planos"
        loading="lazy"
      />
      <h3>{plan.title}</h3>
      <p>{plan.description}</p>
      <span className="span-price"> {plan.price}</span>
        
      <button onClick={() => handleSelectPlan(plan)} className="button-select-plan">Quero este</button>
    </li>
  ));

  return (
    <>

      <section>
        <HeaderNav />
      </section>

      <section className="container-plans">
        <ul>{plans}</ul>
      </section>
    
        <section className="plan-selected">
          {selectedPlan && (
            <div>
              <h2>Plano selecionado:</h2>
              <p>{selectedPlan.title}</p>
              <p>{selectedPlan.price}</p>
            </div>
          )}
        </section>




      <Footer />
    </>
  );
};

export default Plans;
